import React from 'react'
import { useNavigate } from 'react-router-dom'
import { XCircle, ArrowLeft } from 'lucide-react'

export const PaymentCanceled: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-primary via-dark-secondary to-dark-tertiary flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="bg-dark-secondary/50 backdrop-blur-sm border border-primary-600/20 rounded-3xl p-12 text-center">
          {/* Canceled Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-gray-600 to-gray-700 rounded-full flex items-center justify-center mx-auto mb-8">
            <XCircle className="w-14 h-14 text-white" />
          </div>

          {/* Canceled Message */}
          <h1 className="text-4xl font-bold text-light-primary mb-4">
            Payment Canceled
          </h1>

          <p className="text-xl text-light-secondary mb-8">
            No worries! Your payment was not processed and you have not been charged.
          </p>

          {/* Reassurance */}
          <div className="bg-dark-tertiary/50 border border-primary-600/20 rounded-2xl p-6 mb-8">
            <h3 className="text-lg font-semibold text-light-primary mb-4">
              What you can do now:
            </h3>
            <div className="space-y-3 text-left">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-primary-400 text-sm font-bold">•</span>
                </div>
                <p className="text-light-secondary">
                  <span className="font-semibold text-light-primary">Try Again:</span> Return to the pricing page and complete your subscription
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-primary-400 text-sm font-bold">•</span>
                </div>
                <p className="text-light-secondary">
                  <span className="font-semibold text-light-primary">Need Help?</span> Contact our support team if you encountered any issues
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-600/20 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-primary-400 text-sm font-bold">•</span>
                </div>
                <p className="text-light-secondary">
                  <span className="font-semibold text-light-primary">Browse Features:</span> Learn more about what BLP Assistant can do for you
                </p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-4">
            <button
              onClick={() => navigate('/')}
              className="w-full px-8 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white rounded-xl font-semibold text-lg shadow-xl transition-all transform hover:scale-105"
            >
              Return to Pricing
            </button>

            <button
              onClick={() => navigate(-1)}
              className="w-full px-8 py-4 bg-dark-tertiary hover:bg-dark-quaternary text-light-primary rounded-xl font-semibold text-lg border border-primary-600/30 transition-colors flex items-center justify-center space-x-2"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Go Back</span>
            </button>
          </div>

          {/* Reminder */}
          <div className="mt-8 pt-8 border-t border-primary-600/20">
            <p className="text-sm text-light-tertiary">
              Remember: 7-day free trial
            </p>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-light-tertiary text-sm">
            Questions about pricing or features?{' '}
            <a
              href="mailto:support@listeningglass.com"
              className="text-primary-400 hover:text-primary-300 font-medium transition-colors"
            >
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
